
export const BASE_URL = 'https://eat.savori.app';
// Redirection to back-end is handled by _redirects.
export const API_PREFIX = '';
export const MEDIA_PREFIX = '';
